import { ReactElement } from 'react';

import { IconSize, IconWrapper, SettingsIcon } from '@dreryk/react-components';

type TimetablePreferencesModalIconProps = {
   onClick: VoidFunction;
};

export const TimetablePreferencesModalOpenIcon = (props: TimetablePreferencesModalIconProps): ReactElement => {
   return (
      <IconWrapper testId={'openTimetablePreferencesModal'} size={IconSize.NORMAL} onClick={props.onClick}>
         <SettingsIcon />
      </IconWrapper>
   );
};
